import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { graphql, Link } from "gatsby";
import Layout from "../components/Layout";
import { HTMLContent } from "../components/Content";
import { Home, HomeContent } from "./index-page";
import styled from "styled-components";
import Carousel from 'react-elastic-carousel';

const Title = styled.h1`
  padding: 10px 20px 0 20px;

  color: #27213c;
  margin-bottom: 0;
  font-size: 2rem;
  font-family: "Nexa";
  text-align: start;
  text-transform: uppercase;
`;
const Wrapper = styled.div`
  p {
    text-align: start;
    font-size: 14px;
    color: #27213c;
    padding: 0 20px 0 20px;
  }
`;
export const ProjectsSlider = styled.div`
  display: flex;
  place-items: center;
  height: 300px;
  background: ${({ color }) => (color ? color : "transparent")};

  .rec.rec-arrow{
    border: none;
    background: transparent;
    box-shadow: none;
    color: #9a1c1f;
    :hover{
      color: #27213c;
    }
  }
  .rec-dot_active{
    box-shadow: none;
    background: white;
    border: 1px solid #9a1c1f;


  }
  .rec-dot{
    box-shadow: none;
    border: 1px solid white;
    margin: 5px;
    /* content: ""; */
    height: 15px;
    border-radius: 50%;
  }

  .BrainhubCarousel__track .BrainhubCarousel__track--draggable {
    transform: translateX(0) !important;
  }
  .BrainhubCarousel {
    /* height: 200px; */
  }
  .BrainhubCarousel__arrows span {
    width: 15px;
    border-color: #9a1c1f;
  }
  .BrainhubCarousel__arrows {
    background: transparent;
  }
  .BrainhubCarousel__arrows:hover {
    background: transparent;
    span {
      border-color: #27213c;
    }
  }
`;
export const Code = styled.span`
  color: ${({ color }) => (color ? "white" : "#9a1c1f")};
  font-family: "Nexa";
  display: none;
  font-size: 12px;
`;
export const SlideWrap = styled.div`
  margin: 20px;
  /* height: 50%; */
  transition: all 0.2s ease-in-out;
  img {
    margin: 0;
    width: 100px;
  }
  :hover {
    /* transform: scale(1.3);
    margin: 0px 1rem; */
    transform: scale(1.1);
    margin: 36px 1rem;
    ${Code} {
      display: flex;
      justify-content: center;
    }
  }
`;
const FilterText = styled.span``;
const FilterWrapper = styled.div`
  display: flex;
  padding: 10px 20px 0 20px;
`;
const FilterList = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 1rem;
  padding: 0 10px;
`;
export const ServicePostTemplate = ({
  content,
  contentComponent,
  categoriesList,
  description,
  title,
  helmet,
  products,
  color,
}) => {
  const [selected, setSelected] = React.useState([]);
  const [list, setList] = React.useState(products && products.product);

  const handleSelect = (e) => {
    const value = e.currentTarget.value;
    if (selected.includes(value))
      setSelected(selected.filter((c) => c != value));
    else setSelected([...selected, value]);

  };

  React.useEffect(() => {

    var newList = selected.length ? products.product.filter((p) => {
      if (p.category &&selected.includes(p.category)) return p;
    }) :products && products.product ;
    setList(newList|| list);
  }, [selected]);
  return (
    <section className="section">
      {helmet || ""}
      <Wrapper className="container content">
        <div className="columns">
          <div className="column is-10 is-offset-1">
            <Title className="title is-size-2 has-text-weight-bold is-bold-light">
              {title}
            </Title>
            <p>{description}</p>
            {categoriesList.length > 1 && (
              <FilterWrapper>
                <FilterText>Filter by:</FilterText>
                <FilterList>
                  {categoriesList.map((category) => (
                    <div key={category}>
                      <input
                        type="checkbox"
                        value={category}
                        onClick={handleSelect}
                      />
                      <label htmlFor={category}>{category}</label>
                    </div>
                  ))}
                </FilterList>
              </FilterWrapper>
            )}

            <ProjectsSlider color={color}>
              <Carousel
              itemsToShow={3}

              >
                {products &&
                  list?.map((project, index) => (
   
                      <SlideWrap
                        key={index}
                        className="gatsby-image-carousel-wrapper"
                      >
                        <div>
                          <a
                            href={project.link && project.link}
                            target="_blank"
                          >
                            <img
                              src={project.image.childImageSharp?.fluid.src}
                              alt={project.alt}
                            />
                          </a>

                          <Code color={color}>{project.code}</Code>
                        </div>
                      </SlideWrap>
                      // )
                  ))}
              </Carousel>
            </ProjectsSlider>
          </div>
        </div>
      </Wrapper>
    </section>
  );
};

ServicePostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  description: PropTypes.string,
  title: PropTypes.string,
  color: PropTypes.string,

  helmet: PropTypes.object,
};

const ServicePost = ({ data }) => {
  const { markdownRemark: post } = data;
  const allCategories = post.frontmatter.products?.product
    ?.filter((p) => {
      if (p.category != null) {
        if (p.category != undefined) return p.category;
      }
    })
    .map((p) => p.category);
  const categoriesList = Array.from(new Set(allCategories));
  return (
    <Layout>
      <Home color="white" iconColor="red" side="">
        <HomeContent>
          <ServicePostTemplate
            content={post.html}
            contentComponent={HTMLContent}
            description={post.frontmatter.description}
            categoriesList={categoriesList}
            helmet={
              <Helmet titleTemplate="Service | %s">
                <title>{`${post.frontmatter.title}`}</title>
                <meta
                  name="description"
                  content={`${post.frontmatter.description}`}
                />
              </Helmet>
            }
            title={post.frontmatter.title}
            products={post.frontmatter.products}
            color={post.frontmatter.color}
          />
        </HomeContent>
      </Home>
    </Layout>
  );
};

ServicePost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
};

export default ServicePost;

export const pageQuery = graphql`
  query ServicePostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        color
        description
        products {
          product {
            image {
              childImageSharp {
                fluid(maxWidth: 1075, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            title
            code
            category
            alt
            link
          }
        }
      }
    }
  }
`;
